import React, { useEffect, useRef } from "react"
import CrossLogo from "../../../images/rewards/cross.svg"
import ReactSVG from "react-svg"
import { getApiBaseUrl } from "../../../shared_component/utils/urlUtils"
import { connect } from "react-redux"

const ActivateFuelcardModal = ({
  handleDrawer,
  flutterApp,
  user,
  showCloseIcon = true,
  setActivationSuccessful,
  fuelCard
}) => {
  const hostElementRef = useRef(null)
  const activationSuccessfulScreenRef = useRef(null)

  useEffect(() => {
    window._activationSuccessfulScreenInit = () => {
      window._activationSuccessfulScreenInit = () => {}
      activationSuccessfulScreenRef.current = window._activationSuccessfulScreen
      activationSuccessfulScreenRef.current.listenCloseActivationSuccessfulScreen(handleDrawer)
      activationSuccessfulScreenRef.current.listenActivationSuccessful(() =>
        setActivationSuccessful(true)
      )
    }

    const baseURL = getApiBaseUrl()

    if (flutterApp && hostElementRef.current) {
      const data = {
        auth_token: user.authentication_token,
        cardID: fuelCard?.fuel_card_id,
        pin: fuelCard.prompted_id,
        baseURL: baseURL
      }

      flutterApp.addView({
        hostElement: hostElementRef.current,
        viewConstraints: {
          minHeight: showCloseIcon ? 600 : parseInt(document.documentElement.clientHeight * 0.9),
          maxHeight: showCloseIcon ? 600 : parseInt(document.documentElement.clientHeight * 0.9)
        },
        initialData: {
          widget: "activate_card",
          data: JSON.stringify(data)
        }
      })
    }
  }, [flutterApp])

  return (
    <div className="activate-fuelcard-form">
      {showCloseIcon && (
        <ReactSVG onClick={handleDrawer} src={CrossLogo} className="modal-cross-logo" />
      )}
      <div className="p-20">
        <div ref={hostElementRef} />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { flutterApp } = state.flutterInit
  const user = state.user || {}

  return {
    flutterApp: flutterApp,
    user: user
  }
}
export default connect(mapStateToProps)(ActivateFuelcardModal)
